"use client";

import { Box } from "@mui/material";

interface InsetColumnProps {
  children: React.ReactNode;
}

export const InsetColumn = ({ children }: InsetColumnProps) => {
  return (
    <Box
      sx={{
        width: {
          xs: "100%",
          sm: "75%",
        },
        margin: "0 auto",
        marginY: {
          xs: 4, // 32px mobile
          sm: 6, // 48px desktop
        },
        "& img": {
          display: "block",
          marginLeft: "auto",
          marginRight: "auto",
        },
      }}
    >
      {children}
    </Box>
  );
};
